/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import {
  campaignPostListResponseSchema,
  campaignPostSortSchema,
} from '../campaign-schema';
import { CAMPAIGN_POST_SORT } from '../campaign-constants';

export const listRecentPostsPathSchema = z.object({ campaignId: z.string() });

export const listRecentPostsQuerySchema = z.object({
  sort: campaignPostSortSchema.default(CAMPAIGN_POST_SORT.POSTED_AT_DESC),
  page: z.number().int().default(1),
  limit: z.number().int().default(20),
});

export const listRecentPostsOperationResponseSchema =
  campaignPostListResponseSchema;

export type ListRecentPostsInput = {
  path: z.input<typeof listRecentPostsPathSchema>;
  query?: z.input<typeof listRecentPostsQuerySchema>;
  signal?: AbortSignal;
};

export async function listRecentPosts({
  path,
  query,
  signal,
}: ListRecentPostsInput): Promise<
  z.infer<typeof listRecentPostsOperationResponseSchema>
> {
  const parsedPath = listRecentPostsPathSchema.parse(path);
  const parsedQuery = listRecentPostsQuerySchema.parse(query ?? {});

  const response = await socialApiClient.get(
    `campaigns/${parsedPath.campaignId}/recent_posts`,
    {
      signal,
      searchParams: parsedQuery,
    },
  );
  return listRecentPostsOperationResponseSchema.parse(await response.json());
}
